@if ((actionBarComponent$ | async) !== null) {
  <blaze-header>
    <div class="actionbar">
      @if (actionBarComponent$ | async; as actionBarComponent) {
        <ng-container *ngComponentOutlet="actionBarComponent" />
      }

      @if (isReferralEnabled()) {
        <div class="item-with-bg h-24 w-32 rounded-full">
          <blaze-referral type="button" />
        </div>
      }

      <blaze-helpdesk-button />
      <blaze-account-switcher />

      @if (user()) {
        <blaze-action-bar-user />
      }
    </div>
  </blaze-header>
}
